export const BASE_DISCOVERY_PATH = '/discovery';
